module.exports = __webpack_public_path__ + "img/yjzh.34ef68e7.png";